import lightGallery from 'lightgallery';
import lgVideo from 'lightgallery/plugins/video';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

$(document).ready(function () {

    const lg = lightGallery(document.getElementById("lightgallery"), {
        speed: 500,
        plugins: [lgVideo, lgZoom, lgThumbnail],
        selector: '.gallery-item'
    });

    function showFullTabContent() {
        const productDetailInfo = document.querySelector('.product-detail__info--tabcontent')
        if (productDetailInfo) {
            productDetailInfo.classList.add('show-full')

            const productDetailInfoMore = document.querySelector('.product-detail__info-more')
            if (productDetailInfoMore) {
                const more = productDetailInfoMore.querySelector('.product-detail__info-more--more')
                more && more.classList.remove('active')

                const collapse = productDetailInfoMore.querySelector('.product-detail__info-more--collapse')
                collapse && collapse.classList.add('active')
            }
        }
    }

    $('.product-detail__detail--left__main .slider-single').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        asNavFor: ".product-detail__detail--left__thumb",
        prevArrow: $('.product-detail__arrow-left'),
        nextArrow: $('.product-detail__arrow-right'),
    });

    $('.product-detail__detail--left__main-mobile .slider-single').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
    });

    $('.slider-product-mobile').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
    });

    const productDetailThumbItems = document.querySelectorAll('.product-detail-thumb-item')
    if (productDetailThumbItems.length > 0) {
        $('.product-detail__detail--left__thumb').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: '.product-detail__detail--left__main .slider-single',
            dots: false,
            arrows: false,
            focusOnSelect: true
        });
    }

    $('.list-product-relate').css('display', 'block')
    $('.list-product-relate').css('max-height', 'unset')
    $('.list-product-relate').on('init', function(event, slick){
        $('.list-product-relate').css('visibility', 'visible');
    }).slick({
        centerMode: true,
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        prevArrow: $('.product-relate__arrow-left'),
        nextArrow: $('.product-relate__arrow-right'),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    function collapseDescription() {
        const productDetailInfoTabContent = document.querySelector('.product-detail__info--tabcontent')
        if (productDetailInfoTabContent) {
            productDetailInfoTabContent.classList.remove('show-full')

            const productDetailInfoMore = document.querySelector('.product-detail__info-more')
            if (productDetailInfoMore) {
                const more = productDetailInfoMore.querySelector('.product-detail__info-more--more')
                more && more.classList.add('active')

                const collapse = productDetailInfoMore.querySelector('.product-detail__info-more--collapse')
                collapse && collapse.classList.remove('active')
            }
        }
    }

    document.addEventListener('click', function (e) {
        if (e.target.classList.contains('tablinks')) {
            const parentTab = e.target.closest('.product-detail__info--tab')
            if (parentTab) {
                const tabActiveCurrent = parentTab.querySelector('.active')
                tabActiveCurrent && tabActiveCurrent.classList.remove('active')
            }
            e.target.classList.add('active')
            showFullTabContent()
        }

        if (e.target.classList.contains('tablinks')) {
            const parentTab = e.target.closest('.tab')

            if (parentTab) {
                const tabs = parentTab.querySelectorAll('.tablinks')

                if (tabs.length > 0) {
                    tabs.forEach(tab => {
                        tab.classList.remove('active')
                    })
                }
            }
            e.target.classList.add('active')
            const parentWrapper = parentTab.parentElement
            const dataTabTitle = e.target.getAttribute('data-tab-title')
            const tabContents = parentWrapper.querySelectorAll('.tabcontent')

            if (tabContents.length > 0) {
                tabContents.forEach(tabContent => {
                    tabContent.classList.remove('active')

                    if (tabContent.getAttribute('data-tab-content') == dataTabTitle) {
                        tabContent.classList.add('active')
                    }
                })
            }

            collapseDescription()
        }

        if (e.target.classList.contains('variant-item') || e.target.closest('.variant-item')) {
            let target = null
            if (e.target.classList.contains('variant-item')) {
                target = e.target
            } else {
                target = e.target.closest('.variant-item')
            }


            const parent = target.closest('.product-detail__detail--right__variants')
            if (parent) {
                const activeCurrent = parent.querySelector('.active')
                activeCurrent && activeCurrent.classList.remove('active')

                target.classList.add('active')
            }
        }

        if (e.target.classList.contains('product-detail__info-more--more') || e.target.closest('.product-detail__info-more--more')) {
            showFullTabContent()
        }

        if (e.target.classList.contains('product-detail__info-more--collapse') || e.target.closest('.product-detail__info-more--collapse')) {
            collapseDescription()
        }
    })

    if (window.innerWidth < 768) {
        const footerLine = document.querySelector('.footer-line')
        if (footerLine) {
            const formAddToCart = document.querySelector('.form-add-to-cart')
            if (formAddToCart) {
                const heightRealFormATC = formAddToCart.clientHeight
                footerLine.style.marginBottom = heightRealFormATC + 'px'
            }

        }
    }
});